module.exports = __webpack_public_path__ + "img/ruth.bc8025b8.png";